import { SRN_PARTS_DIVIDER } from './srnParser'

export interface AccessPermissionsResponse {
  access: { srns: string[]; permissions: number[] }[]
  permissions: Record<string, number>
}

export const ENFORCED_EMPTY_PERMISSIONS_MODULE_NAME = 'enforcedEmptyPermissions'

export const generateNewMapOfContentPermissions = ({
  data,
  generalSrn,
}: {
  data: AccessPermissionsResponse
  generalSrn: string
}) => {
  const generatedMap = new Map<string, number[]>()

  data?.access
    ?.filter(
      (accessInstance) =>
        accessInstance.srns.length !== 1 ||
        !accessInstance.srns.includes(generalSrn),
    )
    .forEach((accessInstance) =>
      accessInstance.srns.forEach((srn) =>
        generatedMap.set(srn, accessInstance.permissions),
      ),
    )

  return generatedMap
}

// We need to enforce key for clinic in system permissions map as we use existence of key for clinic as check whether we should ask server for data or not
export const generateMapForEmptySystemPermissions = ({
  clinicId,
}: {
  clinicId: number
}) => {
  const dummyModuleKey = `${ENFORCED_EMPTY_PERMISSIONS_MODULE_NAME}-${clinicId}`

  return { [dummyModuleKey]: [] }
}

export const generateNewMapOfSystemPermissions = ({
  data,
  generalSrn,
}: {
  data: AccessPermissionsResponse
  generalSrn: string
}) => {
  const permissions = data?.permissions ?? {}

  const assignedGeneralPermissions = data?.access.find((item) =>
    item.srns.find((srn) => srn === generalSrn),
  )?.permissions

  // This handle situation when user does not have any system permissions - UI does not allow this but without this it may cause infinite loop
  if (!assignedGeneralPermissions || assignedGeneralPermissions.length === 0) {
    return { system: [] }
  }

  const permissionsPerModule = assignedGeneralPermissions.reduce(
    (previousPermissions, currentPermission) => {
      const srnOfPermission = Object.keys(permissions).find(
        (key) => permissions[key] === currentPermission,
      )
      if (srnOfPermission) {
        const [module] = srnOfPermission?.split(SRN_PARTS_DIVIDER) ?? []

        previousPermissions[module] =
          previousPermissions[module]?.length > 0
            ? [...previousPermissions[module], srnOfPermission]
            : [srnOfPermission]
      }

      return previousPermissions
    },
    {} as Record<string, string[]>,
  )

  return permissionsPerModule
}
